import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const WhatsappButtonWrapper = styled(motion.div)`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #25d366;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #128c7e;
  }
  
  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
    bottom: 20px;
    right: 20px;
  }
`;

const IconContainer = styled.div`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  
  i {
    font-size: 24px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    text-align: center !important;
    line-height: 1 !important;
  }
`;

const WhatsappButton = ({ phoneNumber = "918928836738", message = "Hello, I'm interested in booking a property with LSQ Stays" }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Show button when page is scrolled down (same as BackToTop button)
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  
  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    
    // Clean up function
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  
  const openWhatsapp = () => {
    // Format the phone number to ensure it's in the correct format for WhatsApp
    // Remove any non-numeric characters and ensure it starts with country code
    const formattedNumber = phoneNumber.replace(/\D/g, '');
    
    // Ensure the number starts with the country code (e.g., 91 for India)
    const finalNumber = formattedNumber.startsWith('91') ? formattedNumber : `91${formattedNumber}`;
    
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${finalNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <WhatsappButtonWrapper
          onClick={openWhatsapp}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          title="Contact us on WhatsApp"
          aria-label="Contact on WhatsApp"
        >
          <IconContainer>
            <i className="fab fa-whatsapp"></i>
          </IconContainer>
        </WhatsappButtonWrapper>
      )}
    </AnimatePresence>
  );
};

export default WhatsappButton;
